<template>
    <div class="tags" v-if="showTags">

        <ul>
            <li class="tags-li" v-for="(item,index) in tagsList" :class="{'active': isActive(item.path)}" :key="index">
                <router-link :to="item.path" class="tags-li-title">
                    {{item.title}}
                </router-link>
                <span class="tags-li-icon" @click="closeTags(index)"><i class="el-icon-close"></i></span>
            </li>
        </ul>

        <div class="tags-close-box">
            <el-dropdown @command="handleCommand">
                <span>
                    {{name}}<i class="el-icon-arrow-down el-icon--right"></i>
                </span>
                <el-dropdown-menu size="small" slot="dropdown">
                    <el-dropdown-item command="other">关闭其他</el-dropdown-item>
                    <el-dropdown-item command="all">关闭所有</el-dropdown-item>
                    <el-dropdown-item command="loginout">退出登录</el-dropdown-item>
                </el-dropdown-menu>
            </el-dropdown>
        </div>
    </div>
</template>

<script>
    import bus from './bus';

    export default {
        data() {
            return {
                tagsList: [],
                name: localStorage.getItem('realName'),
                updateVisible: false,
                update: {}
            }
        },
        methods: {
            submit() {
            },
            isActive(path) {
                return path === this.$route.fullPath;
            },
            // 关闭单个标签
            closeTags(index) {
                if (this.tagsList[index].path === "/1090000000000000000003") {
                    const h = this.$createElement;
                    this.$msgbox({
                        message: h('div', {class: 'message-box'}, [
                            h('div', {class: 'message-title-box'}, [
                                h('i', {class: 'el-icon-warning message-box-icon'}, ''),
                                h('span', {class: 'message-box-title'}, '是否关闭页面？'),
                            ]),
                            h('div', null, [
                                h('span', {class: 'message-box-main'}, '关闭后，该页面的开方数据将被清空，是否关闭？'),
                            ]),
                        ]),
                        showCancelButton: true,
                        confirmButtonText: '确定',
                        cancelButtonText: '取消',
                    }).then(() => {
                        const delItem = this.tagsList.splice(index, 1)[0];
                        const item = this.tagsList[index] ? this.tagsList[index] : this.tagsList[index - 1];
                        if (item) {
                            delItem.path === this.$route.fullPath && this.$router.push(item.path);
                        } else {
                            this.$router.push('/');
                        }
                    }).catch()
                } else {
                    const delItem = this.tagsList.splice(index, 1)[0];
                    const item = this.tagsList[index] ? this.tagsList[index] : this.tagsList[index - 1];
                    if (item) {
                        console.log('aa')
                        delItem.path === this.$route.fullPath && this.$router.push(item.path);
                    } else {
                        console.log('bb')
                        let menuList = JSON.parse(localStorage.getItem('menus'))
                        if (menuList[0].children.length === 0) {
                            const toPath = '/' + menuList[0].urlAddress
                            if (delItem.path === toPath) {
                                this.tagsList.push(delItem)
                            } else {
                                this.$router.push(toPath);
                            }
                        } else {
                            const toPath = '/' + menuList[0].children[0].urlAddress
                            if (delItem.path === toPath) {
                                this.tagsList.push(delItem)
                            } else {
                                this.$router.push(toPath);
                            }
                        }
                    }
                }
            },
            // 关闭全部标签
            closeAll() {
                this.tagsList = [];
                let menuList = JSON.parse(localStorage.getItem('menus'))
                if (menuList[0].children.length === 0) {
                    const toPath = '/' + menuList[0].urlAddress
                    if (this.$route.fullPath === toPath) {
                        this.tagsList.push({
                            title: this.$route.meta.title,
                            path: this.$route.fullPath,
                            name: this.$route.matched[1].components.default.name
                        })
                    } else {
                        this.$router.push(toPath);
                    }
                } else {
                    const toPath = '/' + menuList[0].children[0].urlAddress
                    if (this.$route.fullPath === toPath) {
                        this.tagsList.push({
                            title: this.$route.meta.title,
                            path: this.$route.fullPath,
                            name: this.$route.matched[1].components.default.name
                        })
                    } else {
                        this.$router.push(toPath);
                    }
                }
            },
            // 关闭其他标签
            closeOther() {
                const curItem = this.tagsList.filter(item => {
                    return item.path === this.$route.fullPath;
                })
                this.tagsList = curItem;
            },
            // 设置标签
            setTags(route) {
                const isExist = this.tagsList.some(item => {
                    return item.path === route.fullPath;
                })
                if (!isExist) {
                    if (this.tagsList.length >= 6) {
                        this.tagsList.shift();
                    }
                    this.tagsList.push({
                        title: route.meta.title,
                        path: route.fullPath,
                        name: route.matched[1].components.default.name
                    })
                }
                bus.$emit('tags', this.tagsList);
            },
            handleCommand(command) {
                if (command === 'loginout') {
                    localStorage.removeItem('menus');
                    localStorage.removeItem('authorization');
                    this.$router.push('/login');
                } else if (command === 'other') {
                    this.closeOther()
                } else if (command === 'all') {
                    this.closeAll();
                } else if (command === 'update') {
                    this.updateVisible = true;
                }
            },
        },
        computed: {
            showTags() {
                return this.tagsList.length > 0;
            }
        },
        watch: {
            $route(newValue, oldValue) {
                this.setTags(newValue);
            }
        },
        created() {
            this.setTags(this.$route);
            // 监听关闭当前页面的标签页
            bus.$on('close_current_tags', () => {
                for (let i = 0, len = this.tagsList.length; i < len; i++) {
                    const item = this.tagsList[i];
                    if (item.path === this.$route.fullPath) {
                        if (i < len - 1) {
                            this.$router.push(this.tagsList[i + 1].path);
                        } else if (i > 0) {
                            this.$router.push(this.tagsList[i - 1].path);
                        } else {
                            this.$router.push('/');
                        }
                        this.tagsList.splice(i, 1);
                        break;
                    }
                }
            })
        }
    }

</script>


<style>
    .tags {
        position: relative;
        height: 48px;
        overflow: hidden;
        background: #fff;
        padding-right: 120px;
        box-shadow: 0 1px 0 0 rgba(238, 238, 238, 1)
    }

    .tags ul {
        box-sizing: border-box;
        width: 100%;
        height: 100%;
    }

    .tags-li {
        float: left;
        margin: 8px 5px 8px 10px;
        border-radius: 3px;
        font-size: 14px;
        overflow: hidden;
        cursor: pointer;
        height: 32px;
        line-height: 32px;
        border: 1px solid rgba(247, 247, 247, 1);
        color: rgba(102, 102, 102, 1);
        background: rgba(247, 247, 247, 1);
        padding: 0 5px 0 12px;
        vertical-align: middle;
        -webkit-transition: all .3s ease-in;
        -moz-transition: all .3s ease-in;
        transition: all .3s ease-in;
    }

    .tags-li:not(.active):hover {
        background: #f8f8f8;
    }

    .tags-li.active {
        color: #fff;
    }

    .tags-li-title {
        float: left;
        max-width: 80px;
        overflow: hidden;
        white-space: nowrap;
        text-overflow: ellipsis;
        margin-right: 5px;
        color: #666;
    }

    .tags-li.active .tags-li-title {
        color: #fff;
    }

    .tags-close-box {
        position: absolute;
        right: 0;
        top: 0;
        height: 48px;
        line-height: 48px;
        font-size: 14px;
        color: rgba(102, 102, 102, 1);
        text-align: right;
        width: 250px;
        background: #fff;
        z-index: 10;
        margin-right: 20px;
    }

    .el-button--small {
        width: 65px;
        height: 32px;
        font-size: 14px;
    }

    .el-button--primary:hover {
        background: rgba(120, 180, 255, 1) !important;
        color: #FFFFFF !important;
        border: none !important;
    }

    .el-button--primary:focus {
        background: rgba(57, 129, 221, 1) !important;
        color: #FFFFFF !important;
        border: none !important;
    }
</style>
